import React from "react";
import { MdAssignment } from "react-icons/md";
import ContactTable from "./shared/ContactTable";

/**
 * @param {Object} props
 * @param {Array} props.contactCards - List of auditor contact demand cards
 * @returns {React.ReactElement} Table of contact demands with details drawer
 */
function ContactDemand({ contactCards }) {
    return (
        <ContactTable
            contactCards={contactCards}
            title="Demandes de contact"
            nameField="auditor_name"
            headerLabel="Auditeur Pro"
            emptyText="Aucune demande de contact"
            footerLabel="Total des demandes"
            icon={MdAssignment}
        />
    );
}

export default ContactDemand;
